import styled from 'styled-components';

import { UserArrowRightIcon, WarningIcon } from '@treams/treams-icons';
import { tokens } from '@treams/treams-ui';

import type { SidebarRowStatus } from '../talentReviewSidebarOrder';

const ICON_SIZE = 16;

const Line = styled.div<{ $tone?: 'info' | 'warning' }>`
	display: flex;
	align-items: center;
	gap: ${tokens.gap.inline}px;
	min-width: 0;
	color: ${(props) =>
		props.$tone === 'warning'
			? tokens.warning.text
			: props.$tone === 'info'
				? tokens.info.text
				: tokens.text.secondary};
	font-family: ${tokens.typography.fontFamily};
	font-size: ${tokens.typography.sizes.small}px;
	line-height: ${tokens.typography.lineHeights.body};
	font-weight: ${tokens.typography.weights.regular};
`;

const Icon = styled.span<{ $color: string }>`
	flex-shrink: 0;
	display: flex;
	color: ${(props) => props.$color};

	svg {
		display: block;
	}
`;

const Text = styled.span`
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export type SidebarStatusLine = {
	status: SidebarRowStatus;
	tone?: 'info' | 'warning';
	text: string;
};

/**
 * Status lines under a sidebar name: a move, missing motivation, outdated, or
 * last review. Used on both the closed row and the open card.
 * @param props component props
 * @param props.lines the statuses to show, in order
 */
export default function TalentReviewSidebarStatus(props: { lines: SidebarStatusLine[] }) {
	return (
		<>
			{props.lines.map((line) => (
				<Line key={line.status} $tone={line.tone}>
					{line.status === 'moved' && (
						<Icon $color={tokens.info.icon} aria-hidden>
							<UserArrowRightIcon size={ICON_SIZE} />
						</Icon>
					)}
					{line.status === 'noMotivation' ||
					line.status === 'noScore' ||
					line.status === 'noMotivationAndScore' ? (
						<Icon $color={tokens.warning.icon} aria-hidden>
							<WarningIcon size={ICON_SIZE} />
						</Icon>
					) : null}
					<Text>{line.text}</Text>
				</Line>
			))}
		</>
	);
}
